// src/context/LanguageContext.js
import React, { createContext, useContext, useState } from 'react';
import { translations } from '../components/translations.js';
import { logDev } from "../utils/logger.js";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('lang') || 'fr';
  });

  logDev("[LanguageContext] initialisation", { lang });

  const t = (key) => {
    const value = translations[lang]?.[key] ?? key;
    return value;
  };

  const changeLanguage = (newLang) => {
    logDev("[LanguageContext] changement de langue", { from: lang, to: newLang });
    setLang(newLang);
    localStorage.setItem('lang', newLang);
  };

  // 🔥 mapping centralisé ici
  const locale = {
    fr: "fr-FR",
    en: "en-US",
    es: "es-ES",
    de: "de-DE"
  }[lang] || "fr-FR";

  return (
    /*<LanguageContext.Provider value={{ lang, locale:lang, setLang: changeLanguage, t }}>*/
    <LanguageContext.Provider value={{ lang, locale, setLang: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
